import Vue from 'vue';
// https://stackoverflow.com/questions/37078423/how-can-add-bootstrap-tooltip-inside-vue-js

Vue.directive('tooltip', function(el, binding){
    $(el).tooltip({
             title: binding.value,
             placement: binding.arg,
             trigger: 'hover',
             delay: {
                 show: binding.modifiers.delay ? 1000 : 0,
                 hide: 0,
             },
             boundary: 'window'
         })
})